
import Schema from 'AppReact/schema';
import { cardData, makeReadyColumn } from 'types';

export default {
  displayConfetti: Schema('boolean', 'primitive', { defaultValue: false }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  inputRef: Schema({}, 'object', { defaultValue: null }),
  selectedRow: Schema('boolean', 'primitive', { defaultValue: false }),
  data: Schema(cardData, 'object', { defaultValue: {} }),
  makeReadyCategory: Schema(makeReadyColumn, 'object', { defaultValue: {} }),
  selectedTagIds: Schema('integer', 'array', { defaultValue: [] }),
  searchVal: Schema('string', 'primitive', { defaultValue: '' }),
  showCheckboxes: Schema('boolean', 'primitive-nullable', { defaultValue: null })
}

